import axios from "axios";
import { Global } from "../../config/global";


// getMessageHistory: Función para traer el historial de sesiones y mensajes
// del chat seleccionado.

export const getMessageHistory = async (idChat) => {
    try {
        let token = localStorage.getItem('token');   //Extraer el token del localStorage.
        let headers = {   //Definir el encabezado de la petición.
            Authorization: `Bearer ${token}`
        };
        let url = Global.url + `chat/sessions/${idChat}`; //Definir el endpoint de la ruta y realizar la petición.
        const response = await axios.get(url, { headers });
        return response.data

    } catch (error) {
        console.log(error);
    }
};